"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Using a react pattern to avoid the 'useMemo' and 'useCallback', where the hook only export the 'state' and 'dispatch', and all the handlers stay out of the hook.

const getInitialRowsPerPage = (customInitialRowsPerPage, paginationOptions) => {
  const canUseCustomInitialRowsPerPage = customInitialRowsPerPage && paginationOptions.includes(customInitialRowsPerPage);
  const initialRowsPerPage = canUseCustomInitialRowsPerPage ? customInitialRowsPerPage : paginationOptions[0];
  return initialRowsPerPage;
};

// Hook
function usePagination({
  paginationOptions,
  initialRowsPerPage
}) {
  const [page, setPage] = React.useState(0);
  const defaultRowsPerPage = React.useRef(getInitialRowsPerPage(initialRowsPerPage, paginationOptions));
  const [rowsPerPage, setRowsPerPage] = React.useState(defaultRowsPerPage.current);
  React.useEffect(() => {
    defaultRowsPerPage.current = getInitialRowsPerPage(initialRowsPerPage, paginationOptions);
    setRowsPerPage(defaultRowsPerPage.current);
  }, [setRowsPerPage, initialRowsPerPage, paginationOptions]);
  const getPaginationProps = (size, isLoading) => ({
    page,
    rowsPerPage,
    count: size,
    onPageChange: (_, newPage) => {
      setPage(newPage);
    },
    onRowsPerPageChange: e => {
      setRowsPerPage(+e.target.value);
      setPage(0);
    },
    rowsPerPageOptions: paginationOptions,
    showFirstButton: true,
    showLastButton: true,
    nextIconButtonProps: isLoading ? {
      disabled: true
    } : undefined,
    backIconButtonProps: isLoading ? {
      disabled: true
    } : undefined,
    component: 'div'
  });
  return {
    getPaginationProps,
    page,
    rowsPerPage,
    paginationOptions,
    setPage
  };
}
var _default = usePagination;
exports.default = _default;